<template>
    <div v-if="bizAuth.viewBill.hasRight" class="page-setting biz-bill parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <financial-bill-filter :isOpen="isFilter" @filterClose="closeFilter" @changeFilter="setFilterQuery"></financial-bill-filter>
        <div class="tool-bar-mask"></div>
        <div class="page-header has-tab">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" :setWord="$route.query.filterWord"></table-search>
                <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div>
                <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                    <ul >
                        <li @click="uploadFile()">
                            <img src="@/assets/img/icon/biz_upload_gray.svg" alt="">
                            上傳對帳單
                        </li>
                        <li @click="downloadExcel()">
                            <img src="@/assets/img/icon/biz_download_gray.svg" alt="">
                            下載對帳總表
                        </li>
                    </ul>
                </dot-large-drop-menu >
                <input 
                    type="file" 
                    ref="upload" 
                    name="avatar" 
                    style="display: none;"
                    accept=".xlsx,.xls"
                    @change="uploadExcel">
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="全部" :selected="selected.all" >
                <bill-total></bill-total>
                <financial-bill-list :isLoading="isLoading" state="ALL"></financial-bill-list>
            </tab>
            <!-- <tab name="欠款" :selected="selected.arrears" >
                <financial-bill-list :isLoading="isLoading" state="OVERDUE"></financial-bill-list>
            </tab> -->
            <tab name="已繳" :selected="selected.paid" >
                <financial-bill-list :isLoading="isLoading" state="COMPLETELY_PAID"></financial-bill-list>
            </tab>
            <tab name="未繳" :selected="selected.unpaid" >
                <financial-bill-list :isLoading="isLoading" state="UNPAID"></financial-bill-list>
            </tab>
            <tab name="部分繳款" :selected="selected.part" >
                <financial-bill-list :isLoading="isLoading" state="PART"></financial-bill-list>
            </tab>
            <!-- <tab name="部分繳款" :selected="selected.unpaid" >
                <financial-bill-list :isLoading="isLoading" state="PARTIAL_PAID"></financial-bill-list>
            </tab> -->
        </tabs>
        <paginate
            v-show="totalPage>1"
            :page-count="totalPage"
            container-class="pagination"
            :prev-text="paginateParams.prevLabel"
            :next-text="paginateParams.nextLabel"
            :click-handler="setPage">
        </paginate>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import financialBillList from '@/components/bussiness/financialReport/billMgt/billMgtList.vue';
import financialBillFilter from '@/components/bussiness/financialReport/billMgt/billMgtFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import billTotal from '@/components/bussiness/financialReport/billMgt/billTotal.vue';
import paginate from 'vuejs-paginate';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            hash: null,
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false,
            isFilter: false,
            insertData: [],
            selected: {
                all: false,
                arrears: false,
                paid: false,
                unpaid: false,
                part: false
            },
            paginateParams:{
                prevLabel: "<img src='"+require('@/assets/img/icon/arror_left_orange.svg')+"' />",
                nextLabel: "<img src='"+require('@/assets/img/icon/arror_right_orange.svg')+"' />",
            },
            componentKey: 0,
            isLoading: true
        }
    },
    created (){
        if (!this.$store) {
            console.error('Vuex store is not available!');
            return;
        }
        
        this.selectTabByHash()
        this.$store.dispatch('getBizBillMgtList')
        .then(()=>{
            this.isLoading = false
        })
        .catch(err => {
            console.error('Failed to load bill list:', err);
            this.isLoading = false;
        })
    },
    mounted () {
        if (this.$analyticsBiz && this.$analyticsBiz.logEvent) {
            this.$analyticsBiz.logEvent('帳單列表', { screen_name: '帳單列表'})
        }
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        const toolBarWrap = document.getElementsByClassName('biz-tool-bar-wrap')[0];
        if (toolBarWrap) {
            toolBarWrap.style.display = 'flex';
        }
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            immediate: true,
            deep: true
        },
        'bizAuth.viewBill.hasRight': function (val) {
            if(!val && this.$store){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                // 修正：使用跨瀏覽器相容的方式獲取 scrollTop
                let scrollTop = window.pageYOffset || 
                               document.documentElement.scrollTop || 
                               document.body.scrollTop || 
                               0;
                
                const toolBarWrap = document.getElementsByClassName('biz-tool-bar-wrap')[0];
                const parentFrame = document.getElementsByClassName('parent-frame')[0];
                
                if(scrollTop >= 50){
                    if (toolBarWrap) {
                        toolBarWrap.style.display = 'none';
                    }
                    if (parentFrame) {
                        parentFrame.style.zIndex = '7';
                    }
                } else {
                    if (toolBarWrap) {
                        toolBarWrap.style.display = 'flex';
                    }
                    if (parentFrame) {
                        parentFrame.style.zIndex = '7';
                    }
                    this.listIsFixed = false;
                }

                if(scrollTop >= 115){
                    this.listIsFixed = true;
                }
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            let billStatus = null
            
            if( hashTag == '#全部' ){
                if (this.$analyticsBiz && this.$analyticsBiz.logEvent) {
                    this.$analyticsBiz.logEvent('帳單列表_全部', { screen_name: '帳單列表_全部'})
                }
                this.selected.all = true
            }else if( hashTag == '#未繳' ){
                if (this.$analyticsBiz && this.$analyticsBiz.logEvent) {
                    this.$analyticsBiz.logEvent('帳單列表_未繳', { screen_name: '帳單列表_未繳'})
                }
                this.selected.unpaid = true
                billStatus = 1
            }else if( hashTag == '#已繳' ){
                if (this.$analyticsBiz && this.$analyticsBiz.logEvent) {
                    this.$analyticsBiz.logEvent('帳單列表_已繳', { screen_name: '帳單列表_已繳'})
                }
                this.selected.paid = true
                billStatus = 2
            }else if( hashTag == '#部分繳款' ){
                if (this.$analyticsBiz && this.$analyticsBiz.logEvent) {
                    this.$analyticsBiz.logEvent('帳單列表_部分繳款', { screen_name: '帳單列表_部分繳款'})
                }
                this.selected.part = true
                billStatus = 4
            }else{
                if (this.$analyticsBiz && this.$analyticsBiz.logEvent) {
                    this.$analyticsBiz.logEvent('帳單列表_全部', { screen_name: '帳單列表_全部'})
                }
                this.selected.all = true
            }
            
            if (!this.$store) {
                console.error('Store is not available');
                return;
            }
            
            this.$store.dispatch('setBizBillMgtFilterQuery', {billStatus: billStatus, page: 1})
            .then(()=>{
                return this.$store.dispatch('getBizBillMgtListV2')
            })
            .then(()=>{
                this.isLoading = false
            })
            .catch(err => {
                console.error('Error in selectTabByHash:', err);
                this.isLoading = false;
            })
        },
        setSelectTabAllFalse: function () {
            this.selected.all = false
            this.selected.arrears = false
            this.selected.unpaid = false
            this.selected.paid = false
            this.selected.part = false
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        openFilter: function () {
            this.isFilter = true
            if (this.$store) {
                this.$store.commit('modalStatus/set_filter_mode', true)
            }
            const parentFrame = document.getElementsByClassName('parent-frame')[0];
            if (parentFrame) {
                parentFrame.style.zIndex = '8';
            }
        },
        closeFilter: function (value) {
            this.isFilter = value
            if (this.$store) {
                this.$store.commit('modalStatus/set_filter_mode', false)
            }
        },
        setFilterWord: function (value) {
            this.isLoading = true
            if (!this.$store) return;
            
            this.$store.dispatch('setBizBillMgtFilterQuery', {keyword: value, page: 1})
            .then(()=>{
                return this.$store.dispatch('getBizBillMgtListV2')
            })
            .then(()=>{
                this.isLoading = false
            })
            .catch(err => {
                console.error('Error in setFilterWord:', err);
                this.isLoading = false;
            })
        },
        setFilterQuery: function (value) {
            // this.$store.dispatch('setBizBillFilterQuery', value)
        },
        setPage: function(page) {
            if (!this.$store) return;
            
            this.$store.dispatch('setBizBillMgtFilterQuery', {page: page})
            .then(()=>{
                return this.$store.dispatch('getBizBillMgtListV2')
            })
            .then(()=>{
                this.isLoading = false
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            })
            .catch(err => {
                console.error('Error in setPage:', err);
                this.isLoading = false;
            })
        },
        uploadFile() {
            const uploadInput = this.$refs.upload;
            if (uploadInput) {
                uploadInput.value = null;
                uploadInput.click();
            }
        },
        uploadExcel: function (e) {
            const file = e.target.files[0];
            if (!file || !this.$store) return;
            
            this.$store.dispatch('uploadPaidBill', e)
            .then(() => {
                console.log('上傳成功');
                return this.$store.dispatch('getBizBillMgtListV2');
            })
            .catch(error => {
                console.error('上傳失敗:', error);
            });
        },
        downloadExcel: function () {
            this.$store.dispatch('bizdownloadBillAccountExcel')
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            isModalMode: 'GET_MODAL_MODE',
            totalPage :'GET_BIZ_BILL_MGT_LIST_TOTAL_PAGE'
        })
    },
    components: {
        financialBillList,
        financialBillFilter,
        TableSearch,
        Breadcrumb,
        Tabs,
        Tab,
        DotLargeDropMenu,
        billTotal,
        paginate
    }
}
</script>
<style lang="scss">
    .page-setting.biz-bill .pagination{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /*  margin-top: -230px; */
      li{
        margin: 0 6px;
      }
      li.active{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        background-color: #eb7859;
        a{
          color: #fff;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/bussiness/financialReport/billMgt/billMgtDefault.vue